module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gb-Hc-Id-Ja.96c51d51.png";